import { MapToContext } from '@utils/objectWithDefault'

export class InventoryDestinations {
  constructor (destinations) {
    MapToContext(this, [], destinations)
  }
}
